// @flow

import ko from 'knockout';
import _ from 'lodash';

import type { Observable } from 'rgs-knockout';

const DEFAULT_OPTIONS = {
	'jsableComplete': function (prev, cur) {
		const prevJS = prev && prev.toJS && prev.toJS();
		const curJS = cur && cur.toJS && cur.toJS();

		return _.isEqual(prevJS, curJS);
	}
};

ko.extenders.comparer = (
	target: Observable<*>,
	options: string | (prev: Observable<*>, cur: Observable<*>) => boolean) => {

	if (typeof options === 'string') {
		if (options in DEFAULT_OPTIONS){
			target.equalityComparer = DEFAULT_OPTIONS[options];
			return;
		}

		throw new Error(`Incompitable comparer type: ${options}`);
	}
	
	target.equalityComparer = options;
};